import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconPackages } from "@tabler/icons-react";
import { ProductosDef } from "./ProductosDef";

export const ProductosIcon = IconPackages;
export const ProductosHelpText = "* Ingrese aquí los productos";

export class Productos extends Entity<ProductosDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new ProductosDef(), parentKeys);
        this.Form = import('./ProductosForm').then((module) => module.ProductosForm);
        this.Title = "Productos";
        this.HelpText = ProductosHelpText;
        this.Icon = ProductosIcon;
    }
}